
export default function AboutHero() {
  return (
    <section 
      className="relative h-96 flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/f2dea2c696306bdab86a0ee5bdf52aad.jpg')`
      }}
    >
      <div className="text-center text-white max-w-4xl mx-auto px-4">
        <h1 className="text-5xl font-bold mb-4 drop-shadow-lg">About NextZen Soccer Academy</h1>
        <p className="text-xl drop-shadow-md">
          Dedicated to developing the next generation of soccer players through excellence, passion, and character
        </p>
      </div>
    </section>
  );
}
